"use client";
import { jsxs as n, jsx as l } from "react/jsx-runtime";
const r = ({
  title: i,
  titleId: a,
  desc: d,
  descId: e,
  ...h
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kn",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": e,
    ...h,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: e, children: d }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "kn-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-80.1 0h682.7v512H-80.1z" }) }) }),
      /* @__PURE__ */ n(
        "g",
        {
          fillRule: "evenodd",
          clipPath: "url(#kn-a)",
          transform: "translate(75.1)scale(.9375)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#ffe900", d: "M-107.8.2h737.6v511.3h-737.6z" }),
            /* @__PURE__ */ l("path", { fill: "#35a100", d: "m-108.2.2.8 368.6L466.6 0z" }),
            /* @__PURE__ */ l("path", { fill: "#c70000", d: "m630.7 511.5-1.4-383.2-579 383.5z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#000001",
                d: "m-107.9 396.6.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#fff",
                d: "m380.4 156.6-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  r as default
};
